import core from '@gin-betting/core';
const {
    utils: { getBettingOptions },
} = core;

export default function getProductName(): string {
    const { host } = window.location;
    const { staticEndpoint } = getBettingOptions().url;

    switch (true) {
        case host === 'ggbet.ru': {
            return 'GGBet.ru';
        }

        case host === 'ggbet.com': {
            return 'GGBet.com';
        }

        case staticEndpoint.includes('ggbet'): {
            return 'GG.BET';
        }

        default: {
            if (__DEV__) {
                return 'GG.BET';
            }

            return 'unknown';
        }
    }
}
